// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2O8kT","upload":"Small_upload__2TQ-L","imageWrap":"Small_imageWrap__rmMeS","removeBtn":"Small_removeBtn__2BvXd"};